import React from "react";
import { MessageCircle } from "lucide-react";

export default function EmptyConversationState() {
  return (
    <div className="flex-1 min-h-0 grid place-items-center px-8">
      <div className="max-w-md w-full rounded-[30px] border border-white/12 bg-white/[0.035] p-8 shadow-[0_20px_60px_rgba(0,0,0,0.34)]">
        <div className="flex items-center gap-3">
          <div className="h-12 w-12 rounded-2xl bg-white/[0.05] border border-white/12 grid place-items-center shadow-[0_10px_28px_rgba(0,0,0,0.22)]">
            <MessageCircle className="text-white/88" size={19} />
          </div>
          <div>
            <div className="text-white font-semibold text-[16px] leading-tight">Select a conversation</div>
            <div className="mt-1.5 text-[13px] text-white/58 leading-snug">
              Pick a chat from your inbox to start messaging.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
